module.exports = __webpack_public_path__ + "img/17.e2d279c9.png";